<script lang="ts">
import { type Snippet } from 'svelte'

type Props = {
	children?: Snippet
}

let { children }: Props = $props()
</script>

<div class="message-content-text">
	{@render children?.()}
</div>

<style lang="postcss">
.message-content-text {
	overflow-wrap: break-word;
	word-break: break-word;
	white-space: pre-wrap;
}

/** Style links inside message content */
:global(.message-content-text a) {
	@apply underline hover-no-underline;
}
</style>
